<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6sO9xF/tc-custom/9781467462358.jpg?1730409764850" alt="This image is the cover for the book The Letter of James, The Pillar New Testament Commentary (PNTC)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Letter of James, The Pillar New Testament Commentary (PNTC)
      </h1>
      <p class="bookDescription body article font2">
        <p>Few New Testament books have been as con­troversial and misunderstood as the letter of James. Its place in the canon was contested by some early Christians, and the reformer Martin Luther called it an “epistle of straw.” The sometimes negative view of the letter among modern theologians, however, is not shared by ordinary believers. Well known and often quoted, James is concise, intensely practical, and filled with memorable metaphors and illustrations. As such, it has become one of the most popular New Testament books in the church. </p><p>This highly original commentary on James by respected New Testament scholar Douglas Moo combines penetrat­ing scholarship with the simplicity of style and pastoral tone characteristic of James itself. After discussing such background issues as authorship, genre, purpose, structure, and theology, Moo provides a verse-by-verse exposition of the text that leads readers to the heart of James’s message—wholehearted commitment to Christ. In addition to expounding the meaning of James, Moo also takes care to provide practical insights for applying that meaning in the church today. </p><p>At once scholarly and accessible, this vol­ume has become a standard commentary on James. The second edition is based upon the newest version of the NIV and incorporates the latest scholarship. It has been expanded, updated, and revised throughout.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Douglas J. Moo
      </h2>
      
      <p class="authorDescription body article"><B>Douglas J. Moo</B> is professor emeritus of biblical studies at Wheaton College. His other commentaries include the New International Commentary on the New Testament volume on Romans and the Pillar New Testament Commentary volume on James. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6321c894